export const TRANSLATIONS_NAMESPACE = 'form-viewer';
export async function loadTranslations(i18n) {
  await Promise.all(i18n.languages.map(async lang => {
    const dataset = await loadLocaleDataset(lang);
    i18n.addResources(lang, TRANSLATIONS_NAMESPACE, dataset);
    i18n.addResources(lang, 'translation', dataset);
  }));
  return i18n;
}
async function loadLocaleDataset(locale) {
  try {
    return await importLocaleDataset(locale);
  } catch (_error1) {
    try {
      return await importLocaleDataset('en');
    } catch (_error2) {
      return {};
    }
  }
}
async function importLocaleDataset(locale) {
  const messages = await import(/* webpackChunkName: "locale-dataset-[request]" */`@wix/locale-dataset-data/resources/translations/messages_${locale}.json`);
  return messages.default;
}
//# sourceMappingURL=translations.js.map